import { render } from "./PriceCreateCard.vue?vue&type=template&id=9ff59574&scoped=true"
import script from "./PriceCreateCard.vue?vue&type=script&lang=js"
export * from "./PriceCreateCard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9ff59574"

export default script